import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Reset16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.5366 5.10495C11.2423 2.59948 8.16207 1.61756 5.65659 2.9118C3.15111 4.20603 2.1692 7.2863 3.46343 9.79178C4.5535 11.7926 6.29444 12.2496 6.29444 12.2496L5.82049 10.0793C5.73844 9.70361 5.97649 9.33254 6.35218 9.2505C6.72787 9.16845 7.09894 9.4065 7.18099 9.78219L7.96978 13.3941C8.05183 13.7698 7.81378 14.1409 7.43809 14.223L3.71777 15.0354C3.34208 15.1175 2.97101 14.8794 2.88897 14.5037C2.80692 14.128 3.04497 13.757 3.42066 13.6749L5.15452 13.2963C5.15452 13.2963 3.27963 12.5411 2.22618 10.4309C0.578983 7.2421 1.82869 3.32175 5.01748 1.67455C8.20627 0.027347 12.1266 1.27705 13.7738 4.46584C15.421 7.65463 14.1713 11.575 10.9825 13.2222C10.0064 13.7264 9.32107 12.513 10.3434 11.9849C12.8489 10.6907 13.8308 7.61043 12.5366 5.10495Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
